import React from 'react'
import { Create, useForm, useSelect } from '@refinedev/antd'
import { Form, Input, Select } from 'antd'
import type { Tables } from '@muaa/shared'

type Job = Tables<'jobs'>
type Profile = Tables<'profiles'>

export function JobCreate() {
  const { formProps, saveButtonProps } = useForm<Job>()

  const { selectProps: profileSelectProps } = useSelect<Profile>({
    resource: 'profiles',
    optionLabel: 'name',
    optionValue: 'user_id',
    pagination: { mode: 'off' },
  })

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Role"
          name="role"
          rules={[{ required: true, message: 'Role is required' }]}
        >
          <Input placeholder="e.g. Software Engineer" />
        </Form.Item>

        <Form.Item
          label="Organization"
          name="org"
          rules={[{ required: true, message: 'Organization is required' }]}
        >
          <Input placeholder="e.g. Acme Corp" />
        </Form.Item>

        <Form.Item
          label="Location"
          name="loc"
          rules={[{ required: true, message: 'Location is required' }]}
        >
          <Input placeholder="e.g. Atlanta, GA or Remote" />
        </Form.Item>

        <Form.Item
          label="Posted By"
          name="posted_by"
          rules={[{ required: true, message: 'Poster is required' }]}
        >
          <Select
            {...profileSelectProps}
            placeholder="Select member"
            showSearch
            filterOption={(input, option) =>
              String(option?.label ?? '')
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          />
        </Form.Item>
      </Form>
    </Create>
  )
}
